import * as React from 'react';
import RegisterFormErrorBoundary from 'src/components/Register/RegisterFormErrorBoundary';
import SuccessRegisterErrorBoundary from 'src/components/SuccessRegister/SuccessRegisterErrorBoundary';
import RegisterForm from '../../components/Register/RegisterForm';
import SuccessRegister from '../../components/SuccessRegister/SuccessRegister';
import './App.css';

interface IStateApp {
  registerSuccess: boolean;
  height?: number;
}
class App extends React.Component<any, IStateApp> {
  private myRef = React.createRef<HTMLDivElement>();
  constructor(props: any) {
    super(props);
    this.state = { registerSuccess: false, height: 0 };
    this.changeRegisterSuccess = this.changeRegisterSuccess.bind(this);
  }

  public componentDidMount() {
    this.setState({ height: this.myRef.current ? this.myRef.current.offsetHeight : 0 });
  }

  public changeRegisterSuccess() {
    this.setState({ registerSuccess: true });
  }

  public render() {
    return (
      <div
        className='App'
        ref={this.myRef}
        style={{ height: this.state.height ? this.state.height + 'px' : 'auto' }}
      >
      {this.state.registerSuccess ? (
        <SuccessRegisterErrorBoundary>
          <SuccessRegister />
        </SuccessRegisterErrorBoundary>
      ) : (
        <RegisterFormErrorBoundary>
          <RegisterForm changeRegisterSuccess={this.changeRegisterSuccess} />
        </RegisterFormErrorBoundary>
      )}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App/App.tsx